import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('BookingItemService', BookingItemService);

  BookingItemService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'BookingItemModalService',
    'ModalWindowConfirmService',
    'FileSaver',
  ];

  function BookingItemService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    BookingItemModalService,
    ModalWindowConfirmService,
    FileSaver
  ) {
    var utils = new UtilService(this);
    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'bookings';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getBookingItem: getBookingItem,
      saveBookingItem: saveBookingItem,
      addGuestToBookingItem: addGuestToBookingItem,
      saveAllGuestToItems: saveAllGuestToItems,
      deleteBookingItem: deleteBookingItem,
      openBookingItemDetail: openBookingItemDetail,
      createBookingItem: createBookingItem,
      openBookingItemList: openBookingItemList,
      downloadBookingItemVoucher: downloadBookingItemVoucher,
      openSendBookingItemVoucherToClient: openSendBookingItemVoucherToClient,
      sendBookingItemVoucherToClient: sendBookingItemVoucherToClient,

      openBookingItemEditCost: openBookingItemEditCost,
      openBookingItemEditPrice: openBookingItemEditPrice,
      openBookingItemEditPickUpTime: openBookingItemEditPickUpTime,
      openBookingItemStandardCostBased: openBookingItemStandardCostBased,
      openBookingItemServiceItemsCostBased: openBookingItemServiceItemsCostBased,
    };

    return service;

    ///////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'date',
      };

      return filter;
    }

    function openBookingItemEditCost(bookingItem, booking, successCallback) {
      BookingItemModalService.editBookingItemCost(bookingItem, booking, successCallback);
    }

    function openBookingItemEditPrice(bookingItem, booking, successCallback) {
      BookingItemModalService.editBookingItemPrice(bookingItem, booking, successCallback);
    }

    function openBookingItemEditPickUpTime(bookingItem, booking, successCallback) {
      BookingItemModalService.editBookingItemPickUpTime(bookingItem, booking, successCallback);
    }

    // get booking item detial
    function getBookingItem(booking_id, item_id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + booking_id + '/booking_items/' + item_id,
        {},
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function saveBookingItem(bookingItem, bookingId) {
      var url = apiUrl + '/' + bookingId + '/booking_items';
      var method = bookingItem.id ? 'put' : 'post';
      url = bookingItem.id ? url + '/' + bookingItem.id : url;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { booking_item: bookingItem }, success, failure);
    }

    function addGuestToBookingItem(bookingItems, guestId) {
      let url = `${environment.apiEndpoint}/booking_items/add_guest_to_booking_item`;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      let params = {
        booking_items: bookingItems,
        guest_id: guestId,
        skip_check_role: true,
      };

      return RestResource.request('put', url, params, success, failure);
    }

    function saveAllGuestToItems(bookingItems, guests) {
      let url = `${environment.apiEndpoint}/booking_items/add_all_guests_to_booking_item`;

      function success(response) {
        utils._successMsg($translate('GUESTS_MODIFIED'));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      let params = {
        booking_items: bookingItems,
        guests: guests,
        skip_check_role: true,
      };

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteBookingItem(bookingItem, bookingId, successCallback) {
      let url = apiUrl + '/' + bookingId + '/booking_items/' + bookingItem.id + '/has_related_data';

      let params = {
        skip_check_role: true,
      };

      let modal_params = {
        mode: 'danger',
        title: 'CANNOT_DELETE_THIS_ITEM',
        requireConfirmation: null,
        body: 'CHECK_THE_RELATED_TRANSACTION_AND_TRY_AGAIN',
        closeButtonLabel: 'ACCEPT',
      };

      function success(response) {
        if (
          (response.data.has_outgoings || response.data.is_invoiced) &&
          bookingItem.status !== 'pending' &&
          bookingItem.status !== 'declined' &&
          bookingItem.status !== 'cancelled'
        ) {
          ModalWindowConfirmService.open(modal_params);
        } else if (
          bookingItem.status === 'pending' ||
          bookingItem.status === 'declined' ||
          bookingItem.status === 'cancelled'
        ) {
          let confirmCallback = function () {
            let url = apiUrl + '/' + bookingId + '/booking_items/' + bookingItem.id;

            function success(response) {
              utils._successMsg($translate('BOOKING_ITEM_DELETED'));

              successCallback(response.data);
            }

            function failure(response) {
              utils._errorMsg(response.data.error);
              return false;
            }

            return RestResource.request('delete', url, {}, success, failure);
          };

          modal_params.title = 'DELETE_BOOKING_ITEM';
          modal_params.requireConfirmation = true;
          modal_params.body = 'THIS_ACTION_CANNOT_BE_UNDONE';

          ModalWindowConfirmService.open(modal_params, confirmCallback);
        } else {
          modal_params.body = 'ITEM_SHOULD_BE_CANCELLED_BEFORE';

          ModalWindowConfirmService.open(modal_params);
        }
      }

      function failure(response) {
        utils._errorMsg(response.data);
        return false;
      }

      return RestResource.request('get', url, params, success, failure);
    }

    // create booking item for a booking when the booking was created on DB
    function createBookingItem(booking_id, item) {
      var itemAddedMsg = $translate('NEW_ADDED_BOOKING_ITEM');
      var itemAddedFlashMsg =
        $translate('BOOKING_ITEM_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
      var itemModifiedMsg = $translate('MODIFIED_BOOKING_ITEM');

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        if (!item.id) {
          //Create
          utils._setFlashMessage(itemAddedFlashMsg);
        }

        return {
          status: true,
          response: response.data,
        };
      }
      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      var url = apiUrl + '/' + booking_id + '/booking_items';

      return RestResource.request('post', url, item, success, failure);
    }

    // open item detail modal (select booking item)
    function openBookingItemDetail(
      productType,
      bookingItem,
      booking,
      documentDateExchangeRate,
      currencies,
      companyBaseCurrencyId,
      successCallback
    ) {
      var bookingItemCopy = angular.copy(bookingItem);
      BookingItemModalService.openBookingItemDetail(
        productType,
        bookingItemCopy,
        booking,
        documentDateExchangeRate,
        currencies,
        companyBaseCurrencyId,
        successCallback
      );
    }

    function openBookingItemList(bookingId) {
      // successCallback
      BookingItemModalService.openBookingItemList(bookingId);
    }

    // download voucher PDF
    function downloadBookingItemVoucher(booking_item, params) {
      var url = `${apiUrl}/${booking_item.booking_id}/booking_items/${booking_item.id}/get_voucher.pdf`;

      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(blobVar, 'voucher_' + booking_item.booking_item_number + '.pdf');
        },
        function () {}
      );
    }

    function openSendBookingItemVoucherToClient(bookingItem, booking, successCallback) {
      BookingItemModalService.openSendBookingItemVoucherToClient(
        bookingItem,
        booking,
        successCallback
      );
    }

    function sendBookingItemVoucherToClient(bookingItemId, bookingId, companyId, clientEmail) {
      var url =
        apiUrl +
        '/' +
        bookingId +
        '/booking_items/' +
        bookingItemId +
        '/send_booking_item_voucher_to_client';

      return RestResource.request(
        'get',
        url,
        { company_id: companyId, email: clientEmail },
        function (response) {
          utils._successMsg($translate('VOUCHER_SENT_TO_CLIENT'));

          return response.data;
        },
        function () {
          utils._errorMsg($translate('VOUCHER_NOT_SENT'));

          return false;
        }
      );
    }

    function openBookingItemStandardCostBased(
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      let bookingItemCopy = angular.copy(bookingItem);
      BookingItemModalService.openBookingItemStandardCostBased(
        bookingItemCopy,
        booking,
        documentDateExchangeRate,
        successCallback
      );
    }

    function openBookingItemServiceItemsCostBased(
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      let bookingItemCopy = angular.copy(bookingItem);
      BookingItemModalService.openBookingItemServiceItemsCostBased(
        bookingItemCopy,
        booking,
        documentDateExchangeRate,
        successCallback
      );
    }
  }
})();
